import angular from 'angular';
import template from './item.html';
import './item.scss';
import { getFirstFocusableInContainer } from '../../../utils/focus-utils';
// iOS Safari frequently dispatches a delayed synthetic click to whatever
// element ends up under the original tap position after the DOM has changed
// (e.g. after a modal animates in over the spot where the user just tapped).
// That ghost click can immediately activate a control inside the freshly
// opened modal — most visibly the bs-select trigger for Camera/Mic in Call
// settings, which then auto-opens its dropdown. Swallowing capture-phase
// clicks on the modal root for a short window after mount absorbs that
// ghost without affecting deliberate user interaction.
const IOS_GHOST_CLICK_SHIELD_MS = 350;
class ModalsItemController {
    constructor($element, $timeout, Browser) {
        this.$element = $element;
        this.$timeout = $timeout;
        this.Browser = Browser;
    }
    $onInit() {
        // Ensure focus moves into the modal when it opens (e.g. from the call menu).
        // Prefer the close control so device-setting selects are not focused on open
        // (which would open their dropdown via bs-select).
        void this.$timeout(() => {
            const root = this.$element[0];
            const closeButton = root.querySelector('.modals-item__close');
            if (closeButton) {
                closeButton.focus();
            }
            else {
                const content = root.querySelector('.modals-item__content');
                const firstFocusable = content && getFirstFocusableInContainer(content);
                firstFocusable?.focus();
            }
            this.installIosGhostClickShield(root);
        }, 0);
    }
    installIosGhostClickShield(root) {
        if (!this.Browser.isIos()) {
            return;
        }
        const swallow = (event) => {
            event.stopImmediatePropagation();
            event.preventDefault();
        };
        root.addEventListener('click', swallow, true);
        void this.$timeout(() => {
            root.removeEventListener('click', swallow, true);
        }, IOS_GHOST_CLICK_SHIELD_MS);
    }
}
const modalsItem = {
    template,
    transclude: true,
    bindings: {
        header: '<',
        closeAriaLabel: '<',
        onClose: '&',
    },
    controller: ModalsItemController,
};
export default angular
    .module('doxy.common.components.modals.item', [])
    // modals-item
    .component('modalsItem', modalsItem).name;
